import { render } from "./WhyChooseUs.vue?vue&type=template&id=cb1748e0&scoped=true"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"

import "./WhyChooseUs.vue?vue&type=style&index=0&id=cb1748e0&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1748e0"]])

export default __exports__